import React, { useState, useEffect, useMemo } from "react";
import DOMPurify from "dompurify";

export default () => {
    const quillModules = useMemo(
        () => ({
            toolbar: [
                [{ font: [] }, { size: [] }],
                ["bold", "italic", "underline", "strike"],
                [{ color: [] }, { background: [] }],
                [{ script: "sub" }, { script: "super" }],
                [{ header: 1 }, { header: 2 }, { align: [] }],
                [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
                ["blockquote", "code-block"],
                ["link"],
                ["clean"],
            ],
            clipboard: { matchVisual: false },
        }),
        []
    );

    const SANITIZE_CFG = {
        ALLOWED_TAGS: [
            "p", "h1", "h2", "h3", "strong", "em", "u", "s", "blockquote", "code", "pre",
            "ul", "ol", "li", "a", "span", "div", "br", "hr"
        ],
        ALLOWED_ATTR: ['class', 'style', 'href', 'rel', 'target', 'src', 'alt', 'title', 'width', 'height'],
    };

    const SafeHtml = ({ html }) => {
        const clean = DOMPurify.sanitize(html || "", SANITIZE_CFG);
        return <div className="safe-html" dangerouslySetInnerHTML={{ __html: clean }} />;
    };

    const quillFormats = [
        "font", "size",
        "bold", "italic", "underline", "strike",
        "color", "background",
        "script",
        "header", "align",
        "list", "bullet", "indent",
        "blockquote", "code-block",
        "link", // "image"
    ];
    return {
        quillModules,
        quillFormats,
        SafeHtml
    }
}